<template>
  <div class="wrapper">
    <div class="main visual-2 abt-hospital">
      <Header :backRoute="'/appointments'" />
      <div class="hospital-info">
        <div class="row">
          <div class="col-lg-7">
            <!-- Hospital Details Section -->
            <div class="hospital-details">
              <div class="hospital-image image-map">
                <img
                  :src="hospitalImage"
                  :alt="hospital?.name || 'Hospital'"
                  class="hospital-img"
                />

                <div class="hospital-map" v-if="hospital?.address">
                  <iframe
                    :src="mapUrl"
                    width="100%"
                    height="400"
                    style="border: 0; border-radius: 10px"
                    allowfullscreen=""
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>

                <!-- <div class="rating">
                  <span>
                    ⭐ {{ roundedAverageRating(hospital) }} ({{
                      formattedTotalReviews(hospital)
                    }}
                    Reviews)
                  </span>
                </div> -->
              </div>
              <div class="hospital-description">
                <div class="h-desc">
                  <h2>{{ hospital?.name }}</h2>
                  <div class="location" v-if="hospital?.address">
                    <i class="fa-solid fa-location-dot"></i>
                    {{ hospital?.address }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5">
            <!-- Specialist Section -->
            <!--dropdown-->
            <div class="d-flex mb-3 gap-2 srch-fltr">
              <input
                v-model="searchName"
                type="text"
                class="form-control"
                placeholder="Search doctor by name"
              />
              <select
                v-model="selectedSpeciality"
                class="form-control doc-dp-srch"
              >
                <option value="">Select Department</option>
                <option
                  v-for="speciality in specialities"
                  :key="speciality"
                  :value="speciality"
                >
                  {{ speciality }}
                </option>
              </select>
            </div>
            <!--dropdown-->
            <div class="doctors-grid">
              <div
                class="specialist-card"
                v-for="specialist in filteredSpecialists"
                :key="specialist.id"
              >
                <div class="specialist-content">
                  <!-- <p class="rating">
                    ⭐ {{ roundedAverageRating(specialist) }}
                  </p> -->
                  <div class="specialist-image">
                    <img
                      :src="specialist.image"
                      :alt="specialist.name"
                      class="doctor-img"
                    />
                  </div>
                  <div class="specialist-data">
                    <p class="specialty">
                      {{ limitedText(specialist.specialty, 15) }}
                    </p>
                    <h4>{{ specialist.name }}</h4>
                    <div class="doc-btn">
                      <router-link :to="`/doctor-bio/${specialist.id}`">
                        <button class="view-btn">
                          {{ specialist.buttonText }}
                        </button>
                      </router-link>
                    </div>
                    <!-- <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <p class="doc-experience m-0">
                        {{ specialist.experienceYears }} yrs exp.
                      </p>
                      <p class="doc-fee m-0">
                        <i class="fa-solid fa-money-bill"></i> Rs.{{
                          specialist.consultationFee
                        }}
                      </p>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterView />
    </div>
  </div>
</template>

<script>
import { DoctorsService } from "@/services/doctors.service";
import FooterView from "@/layout/Footer.vue";
import Header from "../layout/Header.vue";
export default {
  components: {
    FooterView,
    Header,
  },
  name: "HospitalSettings",
  data() {
    return {
      hospital: this.$store?.state?.user?.currentUser?.profile?.hospital,
      specialists: [],
      currentIndex: 0,
      selectedSpeciality: "", // <-- New
      specialities: [],
      searchName: "",
    };
  },
  computed: {
    trackStyle() {
      const translateValue = -(this.currentIndex * 33.33);
      return {
        transform: `translateX(${translateValue}%)`,
        transition: "transform 0.5s ease-in-out",
      };
    },
    filteredSpecialists() {
      return this.specialists
        .filter((doc) => {
          const matchesSpeciality = this.selectedSpeciality
            ? doc.specialty === this.selectedSpeciality
            : true;
          const matchesName = this.searchName
            ? doc.name.toLowerCase().includes(this.searchName.toLowerCase())
            : true;
          return matchesSpeciality && matchesName;
        })
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    mapUrl() {
      if (!this.hospital?.address) return "";
      const encodedAddress = encodeURIComponent(this.hospital.address);
      return `https://www.google.com/maps?q=${encodedAddress}&output=embed`;
    },
    hospitalImage() {
      // Get hospital ID from localStorage
      const storedHospitalId = localStorage.getItem("hospitalId");

      // ✅ Show custom image only for this specific hospital
      if (storedHospitalId === "68d68a07d3f9b7819cd05e80") {
        return require("@/assets/img/494204040_1434613714551416_3095586470864192143_n.jpg");
      }

      // Otherwise, use hospital photo or default image
      return this.hospital?.photo || require("@/assets/img/hospital-img.png");
    },
  },
  methods: {
    roundedAverageRating(data) {
      return data?.averageRating?.averageRating
        ? data.averageRating.averageRating.toFixed(1) // Rounds to 1 decimal place
        : "0.0";
    },
    formattedTotalReviews(data) {
      const reviews = data?.averageRating?.totalReviews || 0;
      if (reviews >= 1_000_000) {
        return (reviews / 1_000_000).toFixed(1) + "M";
      } else if (reviews >= 1_000) {
        return (reviews / 1_000).toFixed(1) + "K";
      }
      return reviews.toString();
    },
    async fetchDoctors() {
      const cacheKey = "cachedDoctorsList";

      // 1. Load cached data first
      const cachedData = localStorage.getItem(cacheKey);
      if (cachedData) {
        try {
          const parsed = JSON.parse(cachedData);
          this.specialists = parsed;

          // Extract unique specialities from cached data
          const allSpecialities = parsed.map((d) => d.specialty);
          this.specialities = [...new Set(allSpecialities)];
        } catch (e) {
          console.warn("Invalid cached doctor data");
        }
      }

      // 2. Fetch updated data in the background
      try {
        const response = await DoctorsService.getList();
        const doctors = response.data.map((doctor) => ({
          id: doctor.id,
          name: doctor.firstname + " " + doctor.lastname,
          specialty: doctor.speciality || "General Physician",
          averageRating: doctor.averageRating || "4.5",
          timings: doctor.timings || "Not Available",
          buttonText: "View Profile",
          image: this.doctorImage(doctor.photo, doctor.gender),
          consultationFee: doctor.consultationFee || "N/A",
          experienceYears: doctor.experienceYears || 0,
        }));

        // Optional: only update if data is different
        const currentData = JSON.stringify(this.specialists);
        const newData = JSON.stringify(doctors);

        if (currentData !== newData) {
          this.specialists = doctors;
          localStorage.setItem(cacheKey, newData);

          const allSpecialities = doctors.map((d) => d.specialty);
          this.specialities = [...new Set(allSpecialities)];
        }
      } catch (error) {
        console.error("Error fetching doctors:", error);
      }
    },
    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    next() {
      if (this.currentIndex < this.specialists.length - 3) {
        this.currentIndex++;
      }
    },
    limitedText(text, charLimit = 20) {
      if (!text) return "";
      return text.length > charLimit ? text.slice(0, charLimit) + "..." : text;
    },
    doctorImage(photoUrl, gender) {
      if (photoUrl) {
        return photoUrl;
      }

      if (gender) {
        const lowerGender = gender.toLowerCase();
        if (lowerGender === "female") {
          return require("@/assets/img/female-doctor.png");
        }
        if (lowerGender === "male") {
          return require("@/assets/img/male-doctor.png");
        }
      }

      return require("@/assets/img/doctor-james.png");
    },
  },
  created() {
    this.fetchDoctors();
  },
};
</script>

<style scoped>
.hospital-map {
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
}
.hospital-image {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: flex-start;
  gap: 20px;
}
</style>
